import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export class ExpertCuratedOfferCtaClickedEvent extends Event {
  static displayName = 'Expert Curated Offer CTA Clicked'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
